import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CategoryMapping } from "app/Model/dataProcess/categoryMapping";
import {lastValueFrom} from "rxjs";

@Injectable()
export class CategoryMappingService {
  private readonly apiUrl = 'api/CategoryMapping';

  constructor(private http: HttpClient) {}

  public getAllCategoryMappingsByCatalogId(catalogId: string, customerId: string): Promise<CategoryMapping[]> {
    const url = `${this.apiUrl}/getCategoryMappingsByCatalogId`;
    const params = new HttpParams().append('catalogId', catalogId).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<CategoryMapping[]>(url, options));
  }

  public update(model: CategoryMapping, customerId: string): Promise<CategoryMapping> {
    const url = `${this.apiUrl}/update`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.post<CategoryMapping>(url, model, options));
  }

  public delete(model: CategoryMapping, customerId: string): Promise<CategoryMapping> {
    const url = `${this.apiUrl}/delete`;
    const params = new HttpParams().append('customerId', customerId).append('id', model.id);
    const options = { params };
    return lastValueFrom(this.http.delete<CategoryMapping>(url, options));
  }
}
